module.exports = __webpack_public_path__ + "static/media/gain.42567120.png";